import { FC, Children } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/List.css'

export type ListProps = {
  isOrdered?: boolean
  theme?: 'table-of-contents'
  marker?: 'bullet-bold'
}

const List: FC<ListProps> = (props) => {
  const { isOrdered, theme, marker, children } = props
  const ListTag = isOrdered ? 'ol' : 'ul'
  const className = cn({
    [styles.orderedList]: isOrdered,
    [styles.unorderedList]: !isOrdered,
    [styles.tableOfContents]: theme === 'table-of-contents',
    [styles.bulletBold]: marker === 'bullet-bold',
  })

  return (
    <ListTag className={ className }>
      {
        Children.map(children, (item, index) => (
          <li key={ index } className={ styles.listItem }>
            { item }
          </li>
        ))
      }
    </ListTag>
  )
}

export default List
